import { render, staticRenderFns } from "./AdvantageImg.vue?vue&type=template&id=19e938b2&scoped=true"
import script from "./AdvantageImg.vue?vue&type=script&lang=js"
export * from "./AdvantageImg.vue?vue&type=script&lang=js"
import style0 from "./AdvantageImg.vue?vue&type=style&index=0&id=19e938b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e938b2",
  null
  
)

export default component.exports